angular.module('callX').service('ManageNumbersService', ['$http', '$rootScope','DateService',
  function ($http,$rootScope, DateService){

    var getAllPromoNumbers = function(callbacks){
          $http.get("/japi/listofallpromonumbers")
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
    };
    var getPendingPromoNumbers = function(callbacks){
          $http.get("/japi/number/allpendingreclamation")
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
    };
    var savePromoNumber = function(promoId, data, callbacks){
          $http.put("/japi/campaign/promo-number/"+promoId, data)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };
    var keepPromoNumber = function(promoId, data, callbacks){
          $http.put("/japi/campaign/promo-number/"+promoId, data)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };
      var removePromoNumber = function(campaignId, callbacks){
          $http.delete("/japi/campaign/promo-number/"+campaignId)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
      };
      var getCampaignsList = function(callbacks){
      $http.get("/japi/campaign/campaign?status=publisher")
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    var addPromoNumberWithDescription = function(campaignId, data, callbacks){
          $http.post("/japi/campaign/" + campaignId + "/promo-number", data)
              .success(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              })
              .error(function (data, status) {
                  if(callbacks !== undefined) { callbacks.success(data, status); }
              });
    };
    return {
      getAllPromoNumbers: function (callbacks) {
        getAllPromoNumbers(callbacks);
      },
      getPendingPromoNumbers: function (callbacks) {
        getPendingPromoNumbers(callbacks);
      },
      savePromoNumber: function ( promoId, data, callbacks) {
          savePromoNumber( promoId, data, callbacks);
      },
      keepPromoNumber: function ( promoId, data, callbacks) {
          keepPromoNumber( promoId, data, callbacks);
      },
        removePromoNumber: function (promoId, callbacks) {
          removePromoNumber(promoId, callbacks);
      },
      getCampaignsList: function (callbacks) {
        getCampaignsList(callbacks);
      },
      addPromoNumberWithDescription: function (campaignId, data, callbacks) {
          addPromoNumberWithDescription(campaignId, data, callbacks);
      }     
    };
  }]);